module.exports = __webpack_public_path__ + "static/media/email-icon.f874a1a9.svg";